import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HintTypeEnum } from 'projects/workspace/src/app/hrm/models/hints-list.model';
import {
  getPackUpHints
} from 'projects/workspace/src/app/warehouse/configs/hints.config';
import { takeUntil } from 'rxjs/operators';
import { QuantityCheckMethodEnum } from '../enums/quantity-check-method.enum';
import {
  BaseMegaHintComponentDependences,
  BaseMegaHintsComponent
} from '../../../../rnpl-common/components/base-mega-hints/base-mega-hints.component';

@Component({
  selector: 'rnpl-pack-up-hints',
  templateUrl: './pack-up-hints.component.html',
  styleUrls: ['./pack-up-hints.component.css']
})
export class PackUpHintsComponent extends BaseMegaHintsComponent implements OnInit, OnChanges {

  @Input() public quantityMethod: QuantityCheckMethodEnum;
  @Input() public selectedProducts: boolean;
  @Input() public isLinkedSo: boolean;
  @Input() public screenName: string;

  constructor(
    public deps: BaseMegaHintComponentDependences
  ) {
    super(deps);
  }

  ngOnInit() {
    this.endFinishText = 'BUTTON.PACK_UP_PRODUCT';
    if (this.shepherdService.isActive) {
      this.shepherdService.cancel();
      this.shepherdService.complete();
    }
    this.displayHints();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('quantityMethod')) {
      clearInterval(this.countdownTimer);
      if (this.shepherdService.isActive) {
        this.shepherdService.complete();
        this.shepherdService.cancel();
        this.animationStateIsPaused$.next(false);
      }

      this.initHints();
    }
  }

  private initHints(): void {
    this.hintsList = [];
    this.notViewedHintsList = [];

    this.hrmService.getHintsByPage(this.screenName)
      .pipe(takeUntil(this._destroy))
      .subscribe(hints => {

        if (!!hints.data.hints && !!hints.data.hints.length) {
          this.hintListByName = getPackUpHints(this.quantityMethod, this.selectedProducts, this.isLinkedSo);

          this.hintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.notViewedHintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !hint.viewed)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.megaHintId = +hints.data.hints[0].id;

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.addHintsSteps(this.notViewedHintsList);
          }

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.shepherdService.start();
          }
        }
      });
  }

}
